import WError from '../components/error.vue';
import modelMixin from './modelMixin';
import titleMixin from './titleMixin';

export default {
  name: 'w-schema-table',
  mixins: [modelMixin, titleMixin],
  data() {
    return {
      staticSlots: ['th_Lp', 'th_RowBtns', 'Lp', 'RowBtns', 'tf_Lp', 'tf_RowBtns']
    };
  },
  props: {
    areLp: {
      type: Boolean,
      default: true
    },
    areRowBtns: {
      type: Boolean,
      default: true
    },
    addRow: {
      type: [String, Boolean],
      default: 'Dodaj wiersz'
    },
    fields: {
      type: [Object, Array],
      default: () => []
    },
    theadRowspan: {
      type: [Number, String],
      default: 1
    }
  },
  computed: {
    isArray() {
      return this.model.$schema.type === 'array';
    },
    isObject() {
      return this.model.$schema.type === 'object';
    },
    properties() {
      const schema = this.model && this.model._internal ? this.model._internal.schema : null;
      let props;
      if (this.isArray) {
        props = schema.items ? schema.items.properties : null;
      } else {
        props = schema ? schema.properties : null;
      }
      let newProps = [];
      Object.keys(props).forEach((key) => {
        let prop = props[key];
        if (!(prop.disabled || key.toLowerCase().includes('guid'))) {
          newProps[key] = prop;
        }
      });
      return newProps;
    },
    flatProperties() {
      let flat = this.removeItems(Object.keys(this.properties), this.staticSlots);
      let flatFields = this.startingWith(this.startingWith(this.removeItems(Object.keys(this.fields), this.staticSlots), 'th_', true), 'tf_', true);
      flat.forEach((element) => {
        if (!flatFields.includes(element)) {
          flatFields.push(element);
        }
      });

      return flatFields.filter((x) => (this.fields[x] ? !this.fields[x].hide : true));
    },
    //remove static slots
    slots() {
      return this.removeItems(Object.keys(this.$scopedSlots), this.staticSlots);
    },
    //tfoot
    thSlots() {
      return this.startingWith(this.slots, 'th_');
    },
    //tbody
    tbSlots() {
      return this.startingWith(this.startingWith(this.slots, 'th_', true), 'tf_', true);
    },
    //tfoot
    tfSlots() {
      return this.startingWith(this.slots, 'tf_');
    }
  },
  methods: {
    removeItems(array, values) {
      let newArray = [...array];
      values.forEach((value) => {
        let index = newArray.indexOf(value);
        if (index > -1) {
          newArray.splice(index, 1);
        }
      });
      return newArray;
    },
    startingWith(array, extract, notstartingWith) {
      let newArray = [];
      let index = 0;
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        if (notstartingWith ? !element.startsWith(extract) : element.startsWith(extract)) newArray[index++] = element;
      }
      return newArray;
    }
  }
};
